"use client";

import { MindstringPrototype } from "@/generated/fastapi";

export function buildMeiliFilterString({
  originId,
  situationId,
  prototype,
  items_ids,
  languageFilters,
}: {
  originId?: string;
  situationId?: string;
  prototype?: MindstringPrototype;
  items_ids?: string[];
  languageFilters?: string[];
}): string {
  const filterConditions: string[] = [];

  if (originId) {
    filterConditions.push(`origin_id = "${originId}"`);
  }
  if (situationId) {
    filterConditions.push(`situation_id = "${situationId}"`);
  }
  if (prototype) {
    filterConditions.push(`prototype = "${prototype}"`);
  }
  if (items_ids && items_ids.length > 0) {
    const idsFilter = items_ids.map((id) => `"${id}"`).join(", ");
    filterConditions.push(`objectID IN [${idsFilter}]`);
  }
  if (languageFilters && languageFilters.length > 0) {
    const langFilter = languageFilters
      .map((lang) => `language = "${lang}"`)
      .join(" OR ");
    filterConditions.push(`(${langFilter})`);
  }

  return filterConditions.join(" AND ");
}

export function buildHybridSearchParams(semanticRatio: number) {
  if (
    semanticRatio === 0 ||
    !process.env.NEXT_PUBLIC_MEILI_EMBEDDER_PROVIDER_NAME
  ) {
    return undefined;
  }

  return {
    semanticRatio,
    embedder: process.env.NEXT_PUBLIC_MEILI_EMBEDDER_PROVIDER_NAME,
  };
}

export function sortSearchResultsByLatestAt<T extends { latest_at: string }>(
  hits: T[],
  order: "asc" | "desc" = "desc",
): T[] {
  return [...hits].sort((a, b) => {
    const dateA = new Date(a.latest_at).getTime();
    const dateB = new Date(b.latest_at).getTime();
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });
}
